import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  createFeedbackAsync,
  getAllFeedbackAsync,
  getFeedbackByIdAsync,
  updateTestFeedbackDataAsync,
} from "./feedback.async";

const initialState = {
  feedbackLoader: false,
  feedbacks: [],
  feedbackadd: [],
  feedbackById: [],
  feedbackupdate: [],
};

export const userFeedbackSlice = createSlice({
  name: "subject",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        getAllFeedbackAsync.pending,
        createFeedbackAsync.pending,
        getFeedbackByIdAsync.pending,
        updateTestFeedbackDataAsync.pending
      ),
      (state) => {
        state.feedbackLoader = true;
      }
    );

    builder.addMatcher(
      isAnyOf(getAllFeedbackAsync.fulfilled),
      (state, action) => {
        state.feedbackLoader = false;
        state.feedbacks = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(createFeedbackAsync.fulfilled),
      (state, action) => {
        state.feedbackLoader = false;
        state.feedbackadd = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(getFeedbackByIdAsync.fulfilled),
      (state, action) => {
        state.feedbackLoader = false;
        state.feedbackById = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(updateTestFeedbackDataAsync.fulfilled),
      (state, action) => {
        state.feedbackLoader = false;
        state.feedbackupdate = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getAllFeedbackAsync.rejected,
        createFeedbackAsync.rejected,
        getFeedbackByIdAsync.rejected,
        updateTestFeedbackDataAsync.rejected
      ),
      (state, action) => {
        state.feedbackLoader = false;
      }
    );
  },
  reducers: {
    emptyUserFeedback: () => initialState,
  },
});

export const { emptyUserFeedback } = userFeedbackSlice.actions;

export default userFeedbackSlice.reducer;
